import { Game } from "./game"

export interface Cup {
  id: number
  name: string
  icon: string
}
// TODO
export const cupMap: Record<Game, Cup[]> = {
  [Game.MK8]: [
    { id: 0, name: "Mushroom", icon: "mushroom" },
    { id: 1, name: "Flower", icon: "flower" },
    { id: 2, name: "Star", icon: "star" },
    { id: 3, name: "Special", icon: "special" },
    { id: 4, name: "Shell", icon: "shell" },
    { id: 5, name: "Banana", icon: "banana" },
    { id: 6, name: "Leaf", icon: "leaf" },
    { id: 7, name: "Lightning", icon: "lightning" },
    { id: 8, name: "Egg", icon: "egg" },
    { id: 9, name: "Triforce", icon: "triforce" },
    { id: 10, name: "Crossing", icon: "crossing" },
    { id: 11, name: "Bell", icon: "bell" },
  ],
  [Game.MK8DX]: [
    { id: 0, name: "Mushroom", icon: "mushroom" },
    { id: 1, name: "Flower", icon: "flower" },
    { id: 2, name: "Star", icon: "star" },
    { id: 3, name: "Special", icon: "special" },
    { id: 4, name: "Shell", icon: "shell" },
    { id: 5, name: "Banana", icon: "banana" },
    { id: 6, name: "Leaf", icon: "leaf" },
    { id: 7, name: "Lightning", icon: "lightning" },
    { id: 8, name: "Egg", icon: "egg" },
    { id: 9, name: "Triforce", icon: "triforce" },
    { id: 10, name: "Crossing", icon: "crossing" },
    { id: 11, name: "Bell", icon: "bell" },
    // { id: 12, name: "Golden Dash", icon: "golden_dash" },
    // { id: 13, name: "Lucky Cat", icon: "lucky_cat" },
    // { id: 14, name: "Turnip", icon: "turnip" },
    // { id: 15, name: "Propeller", icon: "propeller" },
    // { id: 16, name: "Rock", icon: "rock" },
    // { id: 17, name: "Moon", icon: "moon" },
    // { id: 18, name: "Fruit", icon: "fruit" },
    // { id: 19, name: "Boomerang", icon: "boomerang" },
    // { id: 20, name: "Feather", icon: "feather" },
    // { id: 21, name: "Cherry", icon: "cherry" },
    // { id: 22, name: "Acorn", icon: "acorn" },
    // { id: 23, name: "Spiny", icon: "spiny" },
  ],
}
